<div class="vc-modal__innerContainer i18nChoices__modalContent" [ngClass]="{hasLoader: submittingAlert}">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>
  <div class="vc-modal__title" i18n="@@ALERT.MODAL.TITLE">Create an alert</div>
  <div class="vc-modal__content">
    <p class="intro" i18n="@@ALERT.MODAL.INTRO_TAG">You are about to create an alert using the following criteria</p>
    <ul class="alertModal__tagList">
      <ng-container *ngFor="let tag of datas.tags">
        <li *ngIf="!tag.shouldHide" class="alertModal__tag vc-tag vc-tag--outline">
          <ng-container *ngIf="tag !== 'stock_on'"> {{ tag }} </ng-container>
          <ng-container *ngIf="tag === 'stock_on'" i18n="@@DELIVERY_OPTS.EXPRESS"> Express Delivery </ng-container>
        </li>
      </ng-container>
    </ul>
    <p class="alertModal__nbArticles vc-body3" i18n="@@ALERT.MODAL.NB_ARTICLES" *ngIf="nbArticles > 0">
      Number of new items matching this alert each day: {{ nbArticles }}
    </p>
    <div class="alertModal__options"></div>

    <label class="alertModal__optionsLabel" i18n="@@ALERT.MODAL.OPTIONS.LABEL">I would like to receive my alert:</label>
    <div class="vc__select">
      <select
        required
        aria-label="size"
        name="listAlertFrequency"
        class="size__select"
        [(ngModel)]="listAlertFrequency"
      >
        <option [ngValue]="'eachDay'" i18n="@@ALERT.MODAL.OPTIONS.SELECT.EVERY_DAY_MAIL">Every-day by email</option>
        <option
          [ngValue]="'emailAndPush'"
          *ngIf="nbArticles <= articlesLimitPerDay"
          i18n="@@ALERT.MODAL.OPTIONS.SELECT.NOW_MAIL_MOBILE"
          >Immediately, by email and mobile notification</option
        >
        <option
          [ngValue]="'email'"
          *ngIf="nbArticles <= articlesLimitPerDay"
          i18n="@@ALERT.MODAL.OPTIONS.SELECT.NOW_MAIL"
          >Immediately, by email</option
        >
        <option
          [ngValue]="'push'"
          *ngIf="nbArticles <= articlesLimitPerDay"
          i18n="@@ALERT.MODAL.OPTIONS.SELECT.NOW_MOBILE"
          >Immediately, by mobile notification</option
        >
      </select>
    </div>

    <div class="alertModal__actionContainer">
      <button
        class="vc-btn vc-btn--primary vc-btn--medium"
        (click)="createAlert()"
        [disabled]="!listAlertFrequency || submittingAlert"
        i18n="@@ALERT.MODAL.BTN_CREATE"
      >
        Confirm
      </button>
    </div>
  </div>

  <ng-container *ngIf="showSuccess" i18n="@@ALERT.MODAL.ALERT_CREATED">Alert successfully created.</ng-container>

  <ng-container *ngIf="showAlreadyExists" i18n="@@ALERT.MODAL.ALERT_ALREADY_EXISTS"
    >This alert has already been created.</ng-container
  >

  <ng-container *ngIf="showErrors">{{ errorMessage }}</ng-container>
</div>
